import styled from "styled-components";
import { PATH_PAGE, PATH_AUTH } from "../../routes/paths";
import { Link } from "react-router-dom";
import { Button } from "../../components/custom";
import { useDocumentTitle } from "../../hooks/useTitle";
import { Helmet } from "react-helmet";
export default function AdmissionHome() {
  useDocumentTitle("FGMS - Admission");
  return (
    <Container className="d-flex justify-content-center h-100">
      <Helmet>
        <title>Admissions - Apply to Firdaus-Gate Model Schools</title>
        <meta
          name="description"
          content="Apply for admission to Firdaus-Gate Model Schools. Purchase admission forms, continue your application, or check your admission status online."
        />
        <meta
          property="og:title"
          content="Admissions - Firdaus-Gate Model Schools"
        />
        <meta
          property="og:description"
          content="Start your journey with Firdaus-Gate Model Schools. Apply online for quality Islamic education with academic excellence."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.firdaus-gate.com/admission/index"
        />
        <meta
          property="og:image"
          content="https://www.firdaus-gate.com/favicon.ico"
        />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Admissions - Firdaus-Gate Model Schools"
        />
        <meta
          name="twitter:description"
          content="Start your journey with Firdaus-Gate Model Schools. Apply online for quality Islamic education."
        />
        <link
          rel="canonical"
          href="https://www.firdaus-gate.com/admission/index"
        />
      </Helmet>
      <div className="card d-flex flex-column gap-2 p-3">
        <h4>Click to Perform Prefered Action</h4>
        <Button blue>
          <Link to={PATH_PAGE.admissionForm} className="react-router-link">
            Purchase Admission Form
          </Link>
        </Button>
        <Button blue>
          <Link to={PATH_PAGE.continue} className="react-router-link">
            Continue Application
          </Link>
        </Button>
        <Button blue>
          {" "}
          <Link className="react-router-link" to={PATH_AUTH.login}>
            {" "}
            Already a Student?
          </Link>
        </Button>
      </div>
    </Container>
  );
}
const Container = styled.div`
  background: #f5f5f5;
  height: 100vh;
  .card {
    max-width: 500px;
    background: white;
    height: fit-content;
    margin: auto;
  }
`;
